﻿import { useMutation } from 'react-query';
import OrdersApi from '../../../../../OrdersApi';

export function useSaveBrokerSystemConnectionMutation(orderId: number) {
    const mutation = useMutation(
        ({
             objectId,
             contentProviderId,
         }: {
            objectId: string;
            contentProviderId: number;
        }): Promise<boolean> => {
            return OrdersApi.connectBrokerSystem(orderId, objectId, contentProviderId);
        }
    );

    return (objectId: string, contentProviderId: number) =>
        mutation.mutateAsync({objectId, contentProviderId});
}